import { SET_PLAYABLE } from './constants'

// Initial state of the store
const initialState = {}
// Sample state:
// {
//     tq: true,
//     sisi: false,
// }

export default function playable(state = initialState, action) {
    switch (action.type) {
        // Update the list of profiles
        case SET_PLAYABLE: {
            const { serverId, playable: isPlayable } = action.payload
            return {
                ...state,
                [serverId]: isPlayable,
            }
        }

        // Do nothing
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/features/Backend/data/playable/reducer.js